// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading__14ojP","description":"styles_description__x6VRz"};